export default "__VITE_ASSET__DeyPeZ_t__"